<!--
  Legacy body: `upload-review-attachments.html` → `<gtw-efile-review-attachments-ce>`.
  The orange modal header lives on the parent (`submit-action` overlay or
  AngularJS `$uibModal` template). This component renders the tabbed
  attachments list + upload drop zone only.
-->
<div class="efile-review-attachment-upload gtw-web-components">
  @if (loadingAttachments) {
<div class="efile-review-attachment-upload__loader">
    <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
  </div>
}

  @if (!loadingAttachments && efileReviewAttachmentUploadInput) {
<gtw-s3-folder-manager
   
    class="efile-review-attachment-upload__manager"
    [s3FolderManagerInput]="efileReviewAttachmentUploadInput"
    (onFileUpload)="onFileUpload($event)"
    (onFileDelete)="onFileDelete($event)">
  </gtw-s3-folder-manager>
}
</div>
